module.exports = __webpack_public_path__ + "static/img/partner-byd.34f11cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-byd.png
// module id = 4wAF
// module chunks = 34